import axios from "axios";
import {getSelfToken} from '../../_helpers/auth/secureToken'
import {AlbumEndpoint} from '../_constants/api.constant'
export async function getAllAlbumOfUser(creatorId,paramsObj) {
    const response = await axios.get(
        AlbumEndpoint.GETALLOFUSER+ creatorId,
        {   params:paramsObj,
            headers: {
                'Authorization': 'Token ' + getSelfToken(),
            },
        }
    ).then(function (response) {
        return response;
    }).catch(function (error) {
        return error.response;
    });
    return response
}